export default __webpack_public_path__ + "static/media/bootstrap-img.aa74e891.png";